'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PromizeViews = function (_React$Component) {
    _inherits(PromizeViews, _React$Component);

    function PromizeViews(props) {
        _classCallCheck(this, PromizeViews);

        var _this = _possibleConstructorReturn(this, (PromizeViews.__proto__ || Object.getPrototypeOf(PromizeViews)).call(this, props));

        _this.pzUpdateViews = function () {
            var pzCanvasObjects = _extends({}, _this.props.pzCanvasObject);
            pzCanvasObjects && Object.keys(pzCanvasObjects).map(function (viewId) {
                var thumbCanvas = new fabric.StaticCanvas('thumbView_' + viewId, { renderOnAddRemove: true });
                pzLoadCanvasObjects({ pzCurrentView: viewId, pzCanvas: thumbCanvas, pzCanvasObject: pzCanvasObjects });
            });
        };

        _this.pzChangeView = function (viewIndex) {
            _this.props.HomeComponent.setState({ "pzCurrentView": viewIndex }, function () {
                _this.props.HomeComponent.pzReloadCanvasObjects();
            });
        };

        return _this;
    }

    // componentDidMount(){
    //     if (this.props.pzTotalViews > 1) {
    //         this.pzUpdateViews();
    //     }
    // }

    _createClass(PromizeViews, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.pzTotalViews > 1) {
                this.pzUpdateViews();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var pzViews = Object.keys(this.props.pzCustomizer).length > 0 ? JSON.parse(this.props.pzCustomizer.product.model_image) : [];
            return React.createElement(
                React.Fragment,
                null,
                this.props.pzTotalViews > 1 ? React.createElement(PZViews, { pzViews: pzViews, pzCurrentView: this.props.pzCurrentView, pzChangeView: this.pzChangeView }) : ''
            );
        }
    }]);

    return PromizeViews;
}(React.Component);